var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTriangleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.212 8.326a1 1 0 010-1.652l8.225-5.608A1 1 0 0111 1.892v11.216a1 1 0 01-1.563.826z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "triangle-left-f823db3deb4ca209af40fa248dd67b06.svg";
export { SvgTriangleLeft as ReactComponent };